export default "__VITE_ASSET__DvH_rbRS__"